export const TEAM = [
  {
    avatar: "/media/images/Team/isaac-fernandes.jfif",
    name: "Isaac Fernandes",
    designation: "Founder, CEO",
    college: "AIEM",
    linkedIn: "https://www.linkedin.com/in/isaacfernandes2050/",
  },
  {
    avatar: "/media/images/Team/aryan-raul.jfif",
    name: "Aryan Raul",
    designation: "Co-Founder",
    college: "NITK",
    linkedIn: "https://www.linkedin.com/in/aryan-raul-23a7a6227/",
  },
  {
    avatar: "/media/images/Team/dhruv-chawla.jfif",
    name: "Dhruv Chawla",
    designation: "COO",
    college: "PCCE",
    linkedIn: "https://www.linkedin.com/in/dhruvchawla23/",
  },
  {
    avatar: "/media/images/Team/nikhil-rajani.jpg",
    name: "Nikhil Rajani",
    designation: "Lead Strategist",
    college: "IIT KGP",
    linkedIn: "https://www.linkedin.com/in/nikhil-bharat-rajani",
  },
    {
    avatar: "/media/images/Team/shlok-bhosale.jpeg",
    name: "Shlok Uday Bhosale",
    designation: "CPO",
    college: "IIM Calcutta",
    linkedIn: "https://www.linkedin.com/in/shlok-bhosale?utm_source=share_via&utm_content=profile&utm_medium=member_ios",
  },
]